import { manageConstants, uriConstants } from '../../constants'
import { defaultService, manageService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '../'
import history from '../../../route/history'

export const manageActions = {
  readInviteList,
  readInviteList2,
  updateManageUser,
  checkManageUser,
  waitManageUser,
  updateInviteUserDrop,
  changeManageList,
  insertInvtEmail,
  getGroupInfo,
  setGroupAddress,
  setGroupInfo,
  checkDelegate,
  getDelegateUserList,
  createDelegateManager,
  cancelManager,
  resetDelegate,
  verifiPdf,
}

/*********
 사업자 이용자 초대화면 초기 로딩
 **********/

function readInviteList(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_INVITE_LIST + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.LOAD_FAILURE, error))
          dispatch(
            alertActions.success({
              title: '오류',
              message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
              params: {
                type: 'SUCCESS',
                callback: () => {
                  if ((error.response?.data?.errors?.message).indexOf('관리자 권한만') > -1) {
                    history.replace('/')
                  }
                },
              },
            }),
          )
        },
      )
  }
}

function readInviteList2(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_INVITE_LIST2 + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.LOAD_FAILURE, error))
          dispatch(
            alertActions.success({
              title: '오류',
              message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
              params: {
                type: 'SUCCESS',
                callback: () => {
                  if ((error.response?.data?.errors?.message).indexOf('관리자 권한만') > -1) {
                    history.replace('/')
                  }
                },
              },
            }),
          )
        },
      )
  }
}

/******************
 이용자 정보 저장/수정
 *******************/
function updateManageUser(params) {
  console.log('이용자 정보 저장/수정 invtSno:', params.invtSno)
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.UPDATE_INVITE_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.SET_INVITE_USER + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.UPDATE_INVITE_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.UPDATE_INVITE_FAILURE, error))
          // dispatch(apiError(error)) // 기존 소스에서 사용함
        },
      )
  }
}

/*********
 이용자 선택
 **********/
function checkManageUser(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.CHECK_INVITE_REQUEST, params))
  }
}

/*********
 이용자 대기자 선택
 **********/
function waitManageUser(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.WAIT_INVITE_REQUEST, params))
  }
}

/*********
 이용자 선택탈퇴
 **********/
function updateInviteUserDrop(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.UPDATE_DROP_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.SET_INVITE_DROP,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.UPDATE_DROP_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.UPDATE_DROP_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 대기자 모두선택
 **********/

function changeManageList(checkedList) {
  return (dispatch) => {
    dispatch(request(checkedList))
  }

  function request(checkedList) {
    return {
      type: manageConstants.CHECK_WAIT_REQUEST,
      data: checkedList,
    }
  }
}

/*********
 초대이메일전송
 **********/
function insertInvtEmail(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.SEND_INVITE_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.SET_INVITE_MAIL,
        params: params,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.SEND_INVITE_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.SEND_INVITE_FAILURE, error))
          // dispatch(apiError(error)) 기존에 사용하던 소스코드
        },
      )
  }
}

/*********
 사업자 정보 변경 초기 조회
 **********/

function getGroupInfo(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.LOAD_GROUP_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_GROUP_INFO,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.LOAD_GROUP_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.LOAD_GROUP_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 사업자 정보 변경
 **********/
function setGroupInfo(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.UPDATE_GROUP_REQUEST))

    manageService.setGroupInfo(params).then(
      (response) => {
        dispatch(apiAction(manageConstants.UPDATE_GROUP_SUCCESS, response))
      },
      (error) => {
        dispatch(apiAction(manageConstants.UPDATE_GROUP_FAILURE, error))
        dispatch(apiError(error))
      },
    )
  }
}

/*********
 권한 위임여부 체크
 **********/
function checkDelegate() {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.GET_PERMISSION_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_PERMISSION,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.GET_PERMISSION_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.GET_PERMISSION_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 관리자 위임 가능한 사용자 목록 조회
 **********/
function getDelegateUserList() {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.GET_DELEGATE_LIST_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.LIST_DELEGATE_USER,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.GET_DELEGATE_LIST_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.GET_DELEGATE_LIST_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 관리자 위임 신청
 **********/
function createDelegateManager(memberId) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.DELEGATE_PERMISSION_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.DELEGATE_PERMISSION + '/' + memberId,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.DELEGATE_PERMISSION_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.DELEGATE_PERMISSION_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 관리자 위임 신청취소
 **********/
function cancelManager(memberId) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.CANCEL_DELEGATE_REQUEST))

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.DELEGATE_PERMISSION + '/' + memberId,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.CANCEL_DELEGATE_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.CANCEL_DELEGATE_FAILURE, error))
          // dispatch(apiError(error))
        },
      )
  }
}

/*********
 사용자가 입력한 주소로 update
 **********/
function setGroupAddress(item) {
  return (dispatch) => {
    dispatch(request(item))
  }

  function request(item) {
    let addressObj = {}

    addressObj.roadAddr = item.roadAddr
    addressObj.zipno = item.zipNo

    return {
      type: manageConstants.CHANGE_ADDRESS,
      addressObj,
    }
  }
}

/**
 * 위임정보 초기화
 * @returns {{type: string}}
 */
function resetDelegate() {
  return { type: manageConstants.RESET_DELEGATE }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/*********
 위변조확인
 **********/

function verifiPdf(params) {
  return async (dispatch) => {
    dispatch(apiAction(manageConstants.LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.QR_PDF_VERIFICATION,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(manageConstants.LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(manageConstants.LOAD_FAILURE, error))
          dispatch(
            alertActions.success({
              title: '오류',
              message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
              params: {
                type: 'SUCCESS',
                callback: () => {
                  if ((error.response?.data?.errors?.message).indexOf('관리자 권한만') > -1) {
                    history.replace('/')
                  }
                },
              },
            }),
          )
        },
      )
  }
}
